// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"16e74677","547":"83c4abd6","681":"270fd4e8","787":"88c52b1a"}[chunkId] + ".chunk.js";
};